import tagList from './tagList';
import delTag from './delTag';
import updateTag from './updateTag';
import addTag from './addTag';
import tagLinkCompany from './tagLinkCompany';
import getAllTagAndCateList from './getAllTagAndCateList';
import updateTagCategory from './updateTagCategory';
import delTagCategory from './delTagCategory';
import addTagCategory from './addTagCategory';
export default {
    /** 获取标签列表 */
    tagList,
    /** 新增标签 */
    addTag,
    /** 标签更新 */
    updateTag,
    /** 标签删除 */
    delTag,
    /** 标签下关联的公司 */
    tagLinkCompany,
    /** 获取所有标签以及分类 */
    getAllTagAndCateList,
    /** 更新标签分类名称 */
    updateTagCategory,
    /** 删除标签分类 */
    delTagCategory,
    /** 新增标签分类 */
    addTagCategory,
};



// WEBPACK FOOTER //
// ./src/api/tagmodule/index.ts